import {useState, useEffect} from 'react'
import useLabForm from '../hooks/useLabForm';
import { LabItem } from '../utils/types';
import { checkLabSoldout } from '../utils/Scripts';

const SelectBtn:React.FC<{
    isOnline:boolean,
    lab: Partial<LabItem>
}>=({
    isOnline,
    lab
})=>{

    const [soldout, setSoldout] = useState(false)
    const [selected, setSelected] = useState(false)
    const {online, setOnline}:any = useLabForm()
    const {selectedId, setSelectedId}:any = useLabForm()

    function handleClick(){
        if(!soldout){
            setSelectedId(lab.id)
            setOnline(isOnline)
        }
    }

    useEffect(()=>{
        if(selectedId===lab.id&&isOnline===online){
            setSelected(true)
        } else {
            setSelected(false)
        }
    },[selectedId,online])

    useEffect(()=>{
        setSoldout(checkLabSoldout(lab as LabItem, isOnline))
    },[])

    return(
        <div>
            <div style={{float:'left', border:'2px solid #fff', padding:soldout?'5px 10px':'10px', borderRadius:'10px', textDecoration: soldout?'line-through':'none' , cursor:soldout ? 'default' : 'pointer', backgroundColor: soldout ? '#393939' : selected ? '#00952d':'transparent', fontSize:'12px', marginRight:'20px', display:'flex', flexDirection:'column', justifyContent:'center', alignItems:'center'}} onClick={()=>{handleClick()}}>
                <div style={{fontWeight:'600', fontSize:'20px'}}>
                    {lab.date?.slice(0,5)}
                </div>
                <div>
                    {isOnline?'ONLINE':'PRESENCIAL'}
                </div>
            {soldout&&(<div style={{color:'#ff5733', fontSize:'9px', textAlign:'center'}}><span style={{display:'inline-block'}}>ESGOTADO</span></div>)}
            </div>
        </div>
    )
}

export default SelectBtn